import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "settings mb-5" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "fs-3 bg-light rounded d-flex align-items-center p-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "settings", -1)
const _hoisted_5 = { class: "row row-campaign-type" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = {
  for: "typeCode",
  class: "me-3 mb-3"
}
const _hoisted_9 = { class: "row row-name" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "row row-patient-product-input" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "row row-patient-product-input" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "row row-description" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "period mb-4" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "fs-3 bg-light rounded d-flex align-items-center p-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "date_range", -1)
const _hoisted_21 = { class: "row row-dates" }
const _hoisted_22 = { class: "col-12 d-flex align-items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "close", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "row row-status" }
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = {
  for: "statusCode",
  class: "me-3 mb-3"
}
const _hoisted_29 = { class: "d-inline-block mt-4" }
const _hoisted_30 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_31 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_warning = _resolveComponent("alert-warning")!
  const _component_alert_info = _resolveComponent("alert-info")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!
  const _component_input_text_editor = _resolveComponent("input-text-editor")!
  const _component_input_date = _resolveComponent("input-date")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createBlock(_component_dp_form, {
    as: "form",
    onSubmit: _ctx.submitData,
    novalidate: ""
  }, {
    default: _withCtx(({ errors }) => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          (_ctx.reservationCampaign.status_code === 'NEW')
            ? (_openBlock(), _createBlock(_component_alert_warning, {
                key: 0,
                message: _ctx.$t('warningReservationCampaignInactive')
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(_toDisplayString(_ctx.$t('campaignSettings')), 1)
          ]),
          _createVNode(_component_alert_info, {
            "can-use-html": "",
            description: _ctx.$t('descriptionReservationCampaignSettings')
          }, null, 8, ["description"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('campaignType')), 1),
              _createVNode(_component_input_select, {
                modelValue: _ctx.reservationCampaign.type_code,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reservationCampaign.type_code) = $event)),
                name: "typeCode",
                selectText: _ctx.$t('selectText'),
                options: _ctx.typeOptions,
                rules: "required",
                errors: errors,
                disabled: _ctx.mode === _ctx.PageDetailModeEnum.EDIT
              }, null, 8, ["modelValue", "selectText", "options", "errors", "disabled"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_input_text, {
              modelValue: _ctx.reservationCampaign.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reservationCampaign.name) = $event)),
              modelModifiers: { trim: true },
              label: _ctx.$t('name'),
              name: "name",
              rules: "required|max:100",
              errors: errors
            }, null, 8, ["modelValue", "label", "errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_input_checkbox_boolean, {
              modelValue: _ctx.reservationCampaign.is_patient_product_input_enabled,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reservationCampaign.is_patient_product_input_enabled) = $event)),
              label: _ctx.$t('patientCanChooseProduct') + '.',
              name: _ctx.$t('patientCanChooseProduct'),
              class: "mb-3",
              errors: errors
            }, null, 8, ["modelValue", "label", "name", "errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_input_checkbox_boolean, {
              modelValue: _ctx.reservationCampaign.is_sms_communication_enabled,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reservationCampaign.is_sms_communication_enabled) = $event)),
              label: _ctx.$t('activateOrcaSmsCommunication') + '.',
              name: _ctx.$t('activateOrcaSmsCommunication'),
              class: "mb-3",
              errors: errors
            }, null, 8, ["modelValue", "label", "name", "errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_input_text_editor, {
              modelValue: _ctx.reservationCampaign.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reservationCampaign.description) = $event)),
              mode: "basic",
              height: 200,
              label: _ctx.$t('internalDescription'),
              name: _ctx.$t('internalDescription'),
              errors: errors
            }, null, 8, ["modelValue", "label", "name", "errors"])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_17, [
        _createElementVNode("header", _hoisted_18, [
          _createElementVNode("h2", _hoisted_19, [
            _hoisted_20,
            _createTextVNode(_toDisplayString(_ctx.$t('reservationPeriod')), 1)
          ]),
          _createVNode(_component_alert_info, {
            "can-use-html": "",
            description: _ctx.$t('descriptionReservationCampaignPeriod'),
            description2: _ctx.$t('descriptionReservationCampaignPeriod2')
          }, null, 8, ["description", "description2"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_input_date, {
              label: _ctx.$t('begin'),
              placeholder: "DD-MM-JJJJ",
              name: _ctx.$t('begin'),
              modelValue: _ctx.reservationCampaign.begin_date,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reservationCampaign.begin_date) = $event)),
              class: "me-3",
              errors: errors
            }, null, 8, ["label", "name", "modelValue", "errors"]),
            _createVNode(_component_input_date, {
              label: _ctx.$t('end'),
              placeholder: "DD-MM-JJJJ",
              name: _ctx.$t('end'),
              modelValue: _ctx.reservationCampaign.end_date,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.reservationCampaign.end_date) = $event)),
              rules: `comes_after:@${_ctx.$t('begin')},@${_ctx.$t('end')}`,
              class: "me-3",
              errors: errors
            }, null, 8, ["label", "name", "modelValue", "rules", "errors"]),
            (_ctx.reservationCampaign.begin_date || _ctx.reservationCampaign.end_date)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearReservationCampaignPeriod && _ctx.clearReservationCampaignPeriod(...args)), ["prevent"])),
                  class: "btn btn-icon btn-sm mb-3"
                }, _hoisted_24))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('status')), 1),
              _createVNode(_component_input_select, {
                modelValue: _ctx.reservationCampaign.status_code,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.reservationCampaign.status_code) = $event)),
                name: "statusCode",
                selectText: _ctx.$t('selectText'),
                options: _ctx.statusOptions,
                rules: "required",
                errors: errors
              }, null, 8, ["modelValue", "selectText", "options", "errors"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("button", _hoisted_30, [
          _createTextVNode(_toDisplayString(_ctx.$t('save')) + " ", 1),
          (_ctx.isSubmitting)
            ? (_openBlock(), _createElementBlock("span", _hoisted_31))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_router_link, {
          to: {name: 'reservation-campaigns'},
          class: "btn btn-outline-primary ms-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}